export default {
  completed: {
    circleIcon: "green bg--light-green",
    hint: "green",
    icon: "icon-valid-circle"
  },
  editing: {
    circleIcon: "active-red bg--baby-pink",
    hint: "active-red",
    icon: "icon-error-circle"
  },
  error: {
    circleIcon: "active-red bg--baby-pink",
    hint: "active-red",
    icon: "icon-error-circle"
  },
  default: {
    circleIcon: "grey bg--light-grey",
    hint: "grey",
    icon: ""
  }
};
